<template>
  <v-dialog v-model="dialogLeggiQr" max-width="80vw" persistent>
    <v-card>
      <v-card-title class="text-h5">Lettura prodotti da codice QR</v-card-title>
      <v-card-text>
        <v-row dense class="mt-2 mb-5">
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select :disabled="prodottiAggiunti && prodottiAggiunti.length > 0" :items="tipiCodice" outlined dense hide-details label="Tipo codice" v-model="tipoCodice" item-value="descrizione" item-text="descrizione" return-object @change="changeTipoCodice"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-switch v-model="aggiuntaAutomatica"  class="mt-1" inset label="Aggiunta automatica" title="Il codice letto viene aggiunto automaticamente alla lista"></v-switch>
          </v-col>
          <v-col></v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field v-model="qrLetto" background-color="amber lighten-5" label="Codice QR letto" outlined dense autofocus ref="qrLetto" @keyup.enter="onQrLetto"></v-text-field>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-row dense v-if="mostraDettaglio">
          <v-col v-for="(campo, idx) in campiCodice" :key="idx" cols="12" sm="6" md="4" lg="3">
            <v-text-field v-model="esploso[campo.codice]" :label="campo.descrizione" outlined dense>
              <template v-slot:append>
                <v-icon @click="onLockValue(campo)" :color="campo.locked ? 'red' : ''" title="Fissa un valore indipendentemente dal codice letto">{{ campo.locked ? 'mdi-lock-outline' : 'mdi-lock-open-variant-outline' }}</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row justify="end" v-if="mostraDettaglio">
          <v-btn v-if="campiCodice.length > 0" class="mr-5 mb-2" :color="editedIndex >= 0 ? 'info': 'success'" @click="onAggiungiProdotto">{{ editedIndex >= 0 ? 'Salva modifiche' : 'Aggiungi prodotto' }}</v-btn>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-dialog v-model="dialogDelete" max-width="550px">
          <v-card>
            <v-card-title class="text-h5">Confermi la cancellazione del prodotto ?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-data-table
          v-model="selected"
          item-key="id"
          :headers="headers"
          :items="tabVisualizzata === 0 ? prodottiAggiunti : riepilogoProdotti"
          :options.sync="options"
          class="elevation-1"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Codici letti</v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabVisualizzata">
              <v-tab>Dettaglio</v-tab>
              <v-tab>Riepilogo</v-tab>
            </v-tabs>            
          </template>
          <template v-slot:[`item.data`]="{ item }">
            {{ item.data | date }}
          </template>
          <template v-slot:no-data>
            <h3>Ancora nessun prodotto aggiunto</h3>  
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)" title="Modifica il prodotto">mdi-pencil</v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)" title="Cancella il prodotto">mdi-delete</v-icon>
          </template>          
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" class="mr-5"  @click="onAnnulla">Annulla</v-btn>
        <v-btn color="success"  @click="onCarica" title="Carica i prodotti nel documento">Carica i prodotti</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import { validazioni } from '@/mixins/validazioni.js'

export default {
  props: {
    show: Boolean,
    item: Object
  },
  mixins: [
    validazioni
  ],
  data() {
    return {
      dialogDelete: false,
      selected: [],
      totaleDocumenti: 0,
      menuData: false,
      dialogLeggiQr: false,
      editedIndex: -1,
      tipoCodice: null,
      tipiCodice: [],
      riferimentoNumeroLinea: '',
      idDocumento: '',
      numItem: '',
      codiceCommessaConvenzione: '',
      codiceCup: '',
      codiceCig: '',
      options: { itemsPerPage: 50 },
      headers: [],
      prodottiAggiunti: [],
      campiCodice: [],
      esploso: {},
      aggiuntaAutomatica: false,
      qrLetto: '',
      riepilogoProdotti: [],
      tabVisualizzata: null
    }
  },
  watch: {
    show(value) {
      this.dialogLeggiQr = value
      this.pulisciCampi()
      this.prodottiAggiunti = []
    },
    dataDocumento(val) {
      this.dataFormatted = this.formatDate(this.dataDocumento)
    },
    item() {
      this.documentiCollegati = this.item.documentiCollegati || []
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
    tabVisualizzata(value) {
      if (value === 1) {
        this.riepilogoProdotti = this.calcolaRiepilogo()
      }
    }
  },
  async mounted() {
    const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
    this.tipiCodice = impostazioni.importLettureQr || []

    const elDefault = this.tipiCodice.find(x => x.default)
    if (elDefault) {
      this.tipoCodice = elDefault
      this.popolaCampiCodice()
      this.buildHeaders()
    }
  },
  computed: {
    mostraDettaglio() {
      return !this.aggiuntaAutomatica || this.editedIndex !== -1
    }
  },
  methods: {
    onLockValue(campo) {
      campo.locked = !campo.locked
      this.$forceUpdate()
    },
    calcolaRiepilogo(daCaricare) {
      let riepilogo = {}
      for (let p of this.prodottiAggiunti) {
        let chiave = ''
        for (let c of this.campiCodice.filter(x => x.azione === 'raggruppa')) {
          chiave = chiave + p[c.codice]
        }
        let r = riepilogo[chiave]
        if (!r) {
          riepilogo[chiave] = {}
          r = riepilogo[chiave]
          for (let c of this.campiCodice.filter(x => x.azione === 'raggruppa')) {
            const campoCodice = daCaricare ? c.model : c.codice
            r[campoCodice] = p[c.codice]
          }          
        }

        for (let c of this.campiCodice.filter(x => x.azione === 'somma')) {
          const campoCodice = daCaricare ? c.model : c.codice
          r[campoCodice] = r[campoCodice] || 0
          r[campoCodice] = +(r[campoCodice] + p[c.codice]).toFixed(c.decimali || 2)
        }
        for (let c of this.campiCodice.filter(x => x.azione === 'conta')) {
          const campoCodice = daCaricare ? c.model : c.codice
          r[campoCodice] = r[campoCodice] || 0
          r[campoCodice] += 1
        }
      }
      return Object.values(riepilogo)
    },
    buildHeaders() {
      while(this.headers.length > 0) { this.headers.pop() }
      for (let c of this.campiCodice) {
        const col = {
          text: c.descrizione,
          value: c.codice
        }
        this.headers.push(col)
      }
      this.headers.push({ text: 'Actions', value: 'actions', sortable: false })
    },
    onQrLetto() {
      const value = this.qrLetto
      let start = 0, len = 0
      // this.esploso = {}
      for (let c of this.campiCodice) {
        if (c.locked) {
          continue
        }
        len = c.lunghezza
        const subQr = value.substring(start, start + len)
        if (c.tipo === 'numerico') {
          let val = parseFloat(subQr)
          if (c.decimali) {
            val = val / Math.pow(10, c.decimali)
          }
          this.esploso[c.codice] = +val.toFixed(c.decimali || 2)
        } else {
          this.esploso[c.codice] = subQr
        }
        start += len
      }
      this.$forceUpdate()
      if (this.aggiuntaAutomatica) {
        this.onAggiungiProdotto()
      }
    },
    popolaCampiCodice() {
      if (this.tipoCodice) {
        this.campiCodice = this.tipoCodice.campi // .map(x => x.campo)
        this.aggiuntaAutomatica = !!this.tipoCodice.aggiuntaAutomatica
      } else {
        this.campiCodice = []
      }
    },
    changeTipoCodice() {
      this.popolaCampiCodice()
      this.buildHeaders()
      this.setQrFocus()
    },
    onAggiungiProdotto() {
      if (this.editedIndex >= 0) {
        let prodotto = {}
        for (let c of this.campiCodice) {
          prodotto[c.codice] = this.esploso[c.codice]
        }
        Object.assign(this.prodottiAggiunti[this.editedIndex], prodotto)
        this.editedIndex = -1
      } else {
        if (!this.tipoCodice || !this.qrLetto) {
          return
        }
        let prodotto = {}
        for (let c of this.campiCodice) {
          prodotto[c.codice] = this.esploso[c.codice]
        }
        this.prodottiAggiunti.push(prodotto)
      }
      this.pulisciCampi()
      this.setQrFocus()
    },
    setQrFocus() {
      this.$refs.qrLetto.focus()
    },
    pulisciCampi() {
      this.qrLetto = ''
      for (let c of this.campiCodice) {
        if (c.locked) {
          continue
        }        
        this.esploso[c.codice] = ''
      }
    },
    async editItem(item) {
      this.editedIndex = this.prodottiAggiunti.indexOf(item)
      for (let c of this.campiCodice) {
        this.esploso[c.codice] = item[c.codice]
      }
      await this.$nextTick()
      this.$forceUpdate()
    },
    deleteItem (item) {
      this.editedIndex = this.prodottiAggiunti.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },
    async deleteItemConfirm () {
      this.prodottiAggiunti.splice(this.editedIndex, 1)
      this.closeDelete()
    },
    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    onAnnulla() {
      this.editedIndex = -1
      this.dialogLeggiQr = false
      this.$emit('dialog-close')
    },
    onCarica() {
      const riepilogo = this.calcolaRiepilogo(true)
      this.dialogLeggiQr = false
      if (riepilogo.length > 0) {
        this.$emit('carica-prodotti', riepilogo)
      }
    }
  }
}
</script>
